import {
    iAntDesign,
    iBitBucket,
    iBootstrap,
    iChakraUi,
    iClickUp,
    iDaisyUi,
    iExpressJs,
    iFigma,
    iGithub,
    iGitLogo,
    iLaravel,
    iLinuxArch,
    iMongoDB,
    iMui,
    iMySql,
    iNextJs,
    iNodeJs,
    iPostMan,
    iReactJs,
    iReactNative,
    iShadcn,
    iSocketIo,
    iTailwindCss,
    iVsCode,
    iWebRTC,
    iXampp,
} from "../../utilities/ImageImports";
import SkillCard from "./Skills/SkillCard";
import SectionTitle from "./Title/SectionTitle";
import AmbientBg from "./layout/AmbientBg";

const SkillsArea = () => {
    const skillSet = [
        {
            title: "React.js",
            link: "https://react.dev/",
            image: iReactJs,
        },
        {
            title: "Next.js",
            link: "https://nextjs.org/docs/getting-started",
            image: iNextJs,
        },
        {
            title: "Tailwind CSS",
            link: "https://tailwindcss.com/docs",
            image: iTailwindCss,
        },
        {
            title: "Shadcn",
            link: "https://ui.shadcn.com/",
            image: iShadcn,
        },
        {
            title: "WebRTC",
            link: "https://webrtc.org/",
            image: iWebRTC,
        },
        {
            title: "Socket.io",
            link: "https://socket.io/",
            image: iSocketIo,
        },
        {
            title: "Node.js",
            link: "https://nodejs.org/ro/docs",
            image: iNodeJs,
        },
        {
            title: "MongoDB",
            link: "https://www.mongodb.com/docs/",
            image: iMongoDB,
        },
        {
            title: "Express.js",
            link: "https://expressjs.com/",
            image: iExpressJs,
        },
        {
            title: "React Native",
            link: "https://reactnative.dev/docs/getting-started",
            image: iReactNative,
        },
        {
            title: "Laravel",
            link: "https://laravel.com/docs/",
            image: iLaravel,
        },
        {
            title: "MySql",
            link: "https://dev.mysql.com/doc/",
            image: iMySql,
        },
        {
            title: "Git",
            link: "https://git-scm.com/doc",
            image: iGitLogo,
        },
    ];

    const uiKitsLibraries = [
        {
            title: "Bootstrap",
            link: "https://getbootstrap.com/docs/",
            image: iBootstrap,
        },
        {
            title: "Material Ui",
            link: "https://mui.com/material-ui/getting-started/overview/",
            image: iMui,
        },
        {
            title: "Ant Design",
            link: "https://ant.design/docs/react/introduce",
            image: iAntDesign,
        },
        {
            title: "Chakra Ui",
            link: "https://chakra-ui.com/getting-started",
            image: iChakraUi,
        },
        {
            title: "Daisy Ui",
            link: "https://daisyui.com/",
            image: iDaisyUi,
        },
    ];

    const toolSet = [
        {
            title: "Linux",
            link: "https://wiki.archlinux.org/",
            image: iLinuxArch,
        },
        {
            title: "Code OSS",
            link: "https://github.com/microsoft/vscode",
            image: iVsCode,
        },
        {
            title: "Post Man",
            link: "https://www.postman.com/",
            image: iPostMan,
        },
        {
            title: "Xampp",
            link: "https://www.apachefriends.org/docs/",
            image: iXampp,
        },
        {
            title: "Figma",
            link: "https://figma.com",
            image: iFigma,
        },
        {
            title: "Github",
            link: "https://docs.github.com/en",
            image: iGithub,
        },
        {
            title: "Bit Bucket",
            link: "https://bitbucket.org/",
            image: iBitBucket,
        },
        {
            title: "Click Up",
            link: "https://clickup.com/features/docs",
            image: iClickUp,
        },
    ];

    return (
        <div>
            <AmbientBg
                colorClass="bg-teal-200"
                positionClass="translate-x-[10%] translate-y-[-10%] sm:translate-x-[150%] sm:translate-y-[60%]"
            />
            <SectionTitle title="Skills" />
            <div className="pt-5 grid justify-items-center xl:grid-cols-5 lg:grid-cols-4 sm:grid-cols-3 grid-cols-2 items-center gap-5 ">
                {skillSet.map((skill, index) => (
                    <SkillCard
                        linkTo={skill?.link}
                        key={index}
                        title={skill?.title}
                        image={skill?.image}
                    />
                ))}
            </div>

            <div className="pt-10">
                <SectionTitle title="Ui & Libraries" />
            </div>
            <div className="pt-5 grid justify-items-center xl:grid-cols-5 lg:grid-cols-4 sm:grid-cols-3 grid-cols-2 items-center gap-5">
                {uiKitsLibraries.map((skill, index) => (
                    <SkillCard
                        key={index}
                        linkTo={skill?.link}
                        title={skill?.title}
                        image={skill?.image}
                    />
                ))}
            </div>

            <div className="pt-10">
                <SectionTitle title="Tools I use" />
            </div>
            <div className="pt-5 grid justify-items-center xl:grid-cols-5 lg:grid-cols-4 sm:grid-cols-3 grid-cols-2 items-center gap-5">
                <AmbientBg
                    colorClass="bg-emerald-600"
                    positionClass="translate-x-[20%] translate-y-[290%] sm:translate-x-[-70%] sm:translate-y-[10%]"
                />
                <AmbientBg
                    colorClass="bg-slate-400"
                    positionClass="translate-x-[10%] translate-y-[-10%] sm:translate-x-[100%] sm:translate-y-[60%]"
                />
                {toolSet.map((skill, index) => (
                    <SkillCard
                        key={index}
                        linkTo={skill?.link}
                        title={skill?.title}
                        image={skill?.image}
                    />
                ))}
            </div>
        </div>
    );
};

export default SkillsArea;

// const SkillCard = ({ title = "SKILL NAME", image = "123" }) => {
//     return (
//         <div className='dark:bg-cDarkBG2 bg-white shadow-lg rounded-lg p-5 flex flex-col items-center justify-center space-y-3 sm:w-[175px] sm:h-[120px] w-[150px] h-[100px] hover:scale-105 transition-all ease-in-out duration-300'>
//             <div className='sm:h-[65px] sm:w-[65px] w-[45px] h-[45px] flex justify-center'>
//                 <img src={image} alt="" className='w-auto h-full' />
//             </div>
//             <div className='dark:text-cDarkText text-gray-500'>{title}</div>
//         </div>
//     )
// }
